import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { store } from '../../store'



const ReceiveActiveProjectList = (props) => {

	const globalState = useContext(store);
	const { dispatch } = globalState;
	let history = useHistory()


  const [ workOrderList, setworkOrderList] = useState([])

	const fetchData = async () => {

	  const response = await fetch('/api/v1/consultant_active_projects', {
	    headers: {
	      'Content-Type': 'application/json',
	      'Authorization': globalState.state.Authentication
	    },
	    method: 'get'
	  })
	  const responseJson = await response.json()
	  console.log(responseJson)

	  if (response.ok) {
	    setworkOrderList(responseJson)
	  } else {
	    alert.show("Server is down.")
	    return false
	  }
	}

	useEffect( () => {
	  fetchData();
	}, []);



	const work_order_list = workOrderList.map( work_order => {
		return (
    	<tr key={work_order.id}>
	      <td>{work_order.project_detail.title}</td>
	      <td>{work_order.project_detail.company_name}</td>
	      <td>{work_order.project_detail.creator}</td>
	      <td>{work_order.actual_start_date_dv}</td>
	      <td>{work_order.active_project_display_status}</td>
        <td><Link className="link" to={{ pathname: "/project-delivery-page", state: { work_order_id: work_order.id, workOrder: work_order, }}} >Edit</Link></td>
	    </tr>
  	)

  })

  return (
    <div className="container">
      <div className="row g-2 align-items-center">
        <div className="col-md text-start">
          <h2 className="card-title page-title my-3"><FontAwesomeIcon icon="list" /> Active Projects</h2>
        </div>
    	</div>
    	<div className="col-md mt-4">
    		<table className="table table-bordered table-striped table-sm text-start">
				  <thead>
				    <tr>
				      <th scope="col">Project Title/ Work Order</th>
				      <th scope="col">Company</th>
				      <th scope="col">Project Posted by</th>
				      <th scope="col">Project Start Date</th>
				      <th scope="col">Project Status</th>
				      <th scope="col">Project Delivery Page</th>
				    </tr>
				  </thead>
				  <tbody>
			    	{work_order_list}
				  </tbody>
				</table>

    	</div>
    </div>
  );
}

export default ReceiveActiveProjectList;
